module.exports = __webpack_public_path__ + "img/psy.692cdf77.jpg";